var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list"},_vm._l((_vm.maxStars),function(star){return _c('li',{key:star.stars,staticClass:"star",class:{ 'active': star <= _vm.stars },on:{"click":function($event){_vm.editable && _vm.rate(star)}}},[_c('i',{class:star <= _vm.stars ? 'my-icon-xlarge my-icon-star' : 'my-icon-xlarge my-icon-star-empty'})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }